export function formatDateTime(value?: string | null) {
  if (!value) return '—'

  return new Intl.DateTimeFormat('fr-FR', {
    dateStyle: 'medium',
    timeStyle: 'short',
  }).format(new Date(value))
}

export function formatCurrencyFcfa(value?: number | null) {
  return new Intl.NumberFormat('fr-FR').format(value ?? 0) + ' FCFA'
}

export function compact(value?: string | null) {
  if (!value) return '—'
  return value.trim() || '—'
}

export function classNames(...values: Array<string | false | null | undefined>) {
  return values.filter(Boolean).join(' ')
}
